import { createFileRoute, Link } from "@tanstack/react-router";
import { OutboundArrow } from "@/components/OutboundArrow";

const SITE_URL = "https://flaneriet.online";
const TENER_URL = "https://10er.com/flaneriet";

export const Route = createFileRoute("/stoet")({
  head: () => ({
    meta: [
      { title: "Støt Flâneriet – gi' en kop kaffe" },
      {
        name: "description",
        content:
          "Kan du lide roen? Gi' en kop kaffe på 10er. Ingen fordele, ingen adgang – alt indhold og hele arkivet forbliver åbent for alle.",
      },
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: "Flâneriet" },
      { property: "og:title", content: "Støt Flâneriet – gi' en kop kaffe" },
      {
        property: "og:description",
        content:
          "En blid gestus. Ingen binding, ingen fordele – alt forbliver åbent for alle.",
      },
      { property: "og:url", content: `${SITE_URL}/stoet` },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "Støt Flâneriet – gi' en kop kaffe" },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/stoet` }],
  }),
  component: StoetPage,
});

function StoetPage() {
  return (
    <article className="mx-auto max-w-3xl">
      <header className="pt-14 pb-8 text-center border-b border-rule">
        <p className="eyebrow">Støt Flâneriet</p>
        <h1 className="mt-3 font-serif text-[2.4rem] md:text-[3.2rem] leading-[1.04] text-ink">
          Kan du lide roen?
        </h1>
        <p className="mt-4 meta italic max-w-xl mx-auto">
          Gi' en kop kaffe – det er hele idéen.
        </p>
      </header>

      <section className="py-14 font-serif text-[1.15rem] md:text-[1.22rem] leading-[1.8] text-ink-body space-y-7 max-w-2xl mx-auto">
        <p>
          Flâneriet er gratis og kommer til at blive ved med at være det. Der
          er ingen betalingsmur, ingen fordele for donorer, ingen skjult
          "premium". Alt indhold og hele arkivet forbliver åbent for alle –
          det er hele meningen.
        </p>

        <p>
          Men det tager tid at læse på andres vegne. Timer med aviser, essays,
          vinbøger, poesi og køkken hver uge – plus alt det tekniske under
          motorhjelmen. Hvis Flâneriet giver dig ro, en tanke eller et fund
          du blev glad for: så er en kop kaffe en meget fin måde at sige tak
          på.
        </p>

        <p className="italic text-ink-soft">
          Ingen binding. Du støtter Flâneriet på den måde, der passer dig bedst.
          10er håndterer betalingen trygt og enkelt.
        </p>
      </section>

      <section className="pb-14 text-center">
        <a
          href={TENER_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 font-serif text-[13px] font-medium tracking-[0.22em] uppercase text-accent border border-accent px-8 py-4 hover:bg-accent hover:text-paper transition-colors"
        >
          <span className="whitespace-nowrap">Gi' en kop kaffe på 10er<OutboundArrow /></span>
        </a>
        <p className="mt-4 font-mono text-[10.5px] tracking-[0.12em] uppercase text-muted">
          Åbner 10er.com/flaneriet i ny fane
        </p>
      </section>

      <section className="py-10 border-t border-rule text-center">
        <p className="eyebrow">Vores løfte</p>
        <p className="mt-5 font-serif font-light text-[1rem] md:text-[1.05rem] leading-[1.75] italic text-ink-soft max-w-xl mx-auto">
          Ingen sporing. Alle henvisninger fører til den oprindelige kilde.
          Der kommer ikke fordele til dem, der giver – og heller ikke reklamer
          til dem, der ikke gør. Sitet forbliver det
          samme rolige sted for alle.
        </p>
        <p className="mt-6">
          <Link
            to="/om-kuratoren"
            className="font-serif text-accent hover:text-accent-dark underline underline-offset-4 decoration-[0.5px]"
          >
            Mød kuratoren →
          </Link>
        </p>
      </section>
    </article>
  );
}
